export default __webpack_public_path__ + "static/media/3-min.94598170.jpg";